import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import accountBConfig from './en-US/pages/accountB/config';
// Module-based page locale files
import agentProfile from './en-US/pages/agent/profile';
import deviceRegister from './en-US/pages/device/register';
import logRawIngestion from './en-US/pages/log/rawIngestion';
import mallConfig from './en-US/pages/mall/config';
import opsVersion from './en-US/pages/ops/version';
import overviewDashboard from './en-US/pages/overview/dashboard';
import settingDept from './en-US/pages/setting/department';
import settingDict from './en-US/pages/setting/dictionary';
import settingMenu from './en-US/pages/setting/menu';
import settingRole from './en-US/pages/setting/role';
import settingUser from './en-US/pages/setting/user';
import tenantList from './en-US/pages/tenant/list';
import tenantPackage from './en-US/pages/tenant/package';
import tenantStore from './en-US/pages/tenant/store';
import pwa from './en-US/pwa';
import validators from './en-US/validators';

export default {
  ...menu,
  ...pwa,
  ...pages,
  ...component,
  ...globalHeader,
  ...agentProfile,
  ...settingUser,
  ...settingRole,
  ...settingDept,
  ...settingMenu,
  ...settingDict,
  ...tenantList,
  ...tenantStore,
  ...tenantPackage,
  ...deviceRegister,
  ...logRawIngestion,
  ...overviewDashboard,
  ...accountBConfig,
  ...mallConfig,
  ...opsVersion,
  ...validators,
};
